import { ChainId, EvmChainId } from '@injectivelabs/ts-types';
const INJ_DENOM = 'inj';
export const getMainnetChainInfo = () => ({
    feeDenom: INJ_DENOM,
    chainId: ChainId.Mainnet,
    evmChainId: EvmChainId.Mainnet,
    env: 'mainnet',
});
export const getTestnetChainInfo = () => ({
    feeDenom: INJ_DENOM,
    chainId: ChainId.Testnet,
    evmChainId: EvmChainId.Sepolia,
    env: 'testnet',
});
export const getDevnetChainInfo = () => ({
    feeDenom: INJ_DENOM,
    chainId: ChainId.Devnet,
    evmChainId: EvmChainId.Sepolia,
    env: 'devnet',
});
export const getLocalChainInfo = () => ({
    feeDenom: INJ_DENOM,
    chainId: ChainId.Mainnet,
    evmChainId: EvmChainId.Mainnet,
    env: 'local',
});
